import { Checkbox } from '@/fsd/shared/ui/checkbox/checkbox';
import LineSVG from '@/fsd/shared/ui/icons/Line';
import { useEffect, useRef } from 'react';
import { Column } from '../../model/types/Column';
import styles from './table-settings.module.scss';

interface TableSettingsProps {
  isOpen: boolean;
  onClose: () => void;
  columns: Column[];
  onToggleColumn: (columnId: string) => void;
  onToggleAllColumns: (isVisible: boolean) => void;
  settingsButtonRef: React.RefObject<HTMLElement>;
}

export const TableSettings = ({
  isOpen,
  onClose,
  columns,
  onToggleColumn,
  onToggleAllColumns,
  settingsButtonRef,
}: TableSettingsProps) => {
  const tableSettingsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        tableSettingsRef.current &&
        !tableSettingsRef.current.contains(event.target as Node) &&
        settingsButtonRef.current &&
        !settingsButtonRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose, settingsButtonRef]);

  const allColumnsSelected = columns.every((column) => column.isVisible);

  if (!isOpen) return null;

  return (
    <div ref={tableSettingsRef} className={styles.tableSettings}>
      <div className={styles.header}>Настройка таблицы</div>
      <div className={styles.column}>
        <div className={styles.head}>
          <span className={styles.label}>Столбцы</span>
          <LineSVG />
          <span className={styles.checkAll}>
            Выбрать все
            <Checkbox
              checked={allColumnsSelected}
              onChange={(checked) => onToggleAllColumns(checked)}
            />
          </span>
        </div>
        {columns.map((column) => (
          <div key={column.id} className={styles.item}>
            <Checkbox
              checked={column.isVisible}
              onChange={() => onToggleColumn(column.id)}
            />
            <span>{column.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
